import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { UserService } from '../../services/userService';
import { Router } from '@angular/router';
//import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-password-reset',
  templateUrl: './password-reset.component.html',
  styleUrls: ['./password-reset.component.css']
})
export class PasswordResetComponent implements OnInit {

  constructor(private formBulder: FormBuilder, private userService: UserService,private router: Router) { }
  resetForm: FormGroup;

  ngOnInit() {
  this.buildForm()
  }

  buildForm() {
    this.resetForm = this.formBulder.group({
      Email: ['', [Validators.required, Validators.pattern('[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}')]]
    });
  }

  resetPassword(resetData) {
    this.userService.resetPassword(resetData.Email).subscribe(data => {
      //if (data) {
      //  if (!this.authService.IsAuthenticated()) {
      //    this.authService.authenticate();
      //  }
      //}
      this.router.navigate(['password-reset-result']);
    });
  }
}
